const url = (value: string): string | null => {
  if (!value) {
    return null;
  }

  const regex =
    /^https?:\/\/((localhost)|([\w-]+\.)+[\w-]+)(:\d+)?([/?#][\w\-._~:/?#[\]@!$&'()*+,;=%]*)?$/i;

  return regex.test(value) ? null : 'Informe uma URL válida iniciando com http:// ou https://';
};

export default url;
